import React, { useContext } from 'react';
import _noop from 'lodash/noop';
import { ModalContext } from 'commons-ui';
import CreateTicket from './components/createTicket/CreateTicket';
import { ContentPropsT } from './components/createTicket/constants';

type Action = {
	id: string;
	isEnabled: () => boolean;
	name: string;
};

export const makeActionHandler = (action: Action, params: ContentPropsT) => {
	const { setModalConfig } = useContext(ModalContext);
	const { handleForceUpdate = _noop, createTicket } = params;
	const handleFilterFormClose = () => {
		setModalConfig({ isOpen: false });
	};
	switch (action.id) {
		case 'add':
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Enter Ticket Fields',
					content: (
						<CreateTicket
							handleForceUpdate={handleForceUpdate}
							onClose={handleFilterFormClose}
							createTicket={createTicket}
						/>
					)
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
